document.addEventListener('DOMContentLoaded', function () {
	const gridButton = document.getElementById('grid-view-btn');
	const listButton = document.getElementById('list-view-btn');
	const archiveGrid = document.querySelector('.post-grid__archive-grid');

	// Função para alterar a cor do stroke
	function updateStrokeColors(activeButton, inactiveButton) {
		// Atualiza a cor do botão ativo
		activeButton.querySelectorAll('path').forEach((path) => {
			path.setAttribute('stroke', '#6C3200'); // Verde
		});
		// Atualiza a cor do botão inativo
		inactiveButton.querySelectorAll('path').forEach((path) => {
			path.setAttribute('stroke', '#24400C'); // Marrom
		});
	}

	gridButton.addEventListener('click', function () {
		archiveGrid.classList.remove('post-grid__archive-grid--line');
		updateStrokeColors(gridButton, listButton);
	});

	listButton.addEventListener('click', function () {
		archiveGrid.classList.add('post-grid__archive-grid--line');
		updateStrokeColors(listButton, gridButton);
	});
});
